<div class="container-header">
  <div class="pull-left text-muted">
    <i class="fa fa-calendar" aria-hidden="true"></i> <strong>Últimas visitas</strong>
    <i class="icon-info text-muted" aria-hidden="true"
      uib-tooltip="Exibição das últimas localizações das máquinas. Nesta tela são exibidos somentes dados referentes aos últimos 30 dias. Para visualizar outros dados navegue pelo calendário."
      tooltip-placement="bottom" tooltip-append-to-body="true"></i>
  </div>
  <div class="pull-right text-muted">
    <i class="icon-updated pointer" aria-hidden="true" ng-click="maquinas.refresh()" title="Atualizar"></i>
  </div>
  <div class="clear"></div>

  <div class="title text-center">
    <h2>
      <strong>Máquinas em Tempo Real</strong>
    </h2>
  </div>

  <div class="input-group">
    <input type="text"
      autofocus
      class="form-control"
      placeholder="Buscar máquinas" ng-model="maquinas.search">
    <span class="input-group-addon">
      <i class="fa fa-search" aria-hidden="true"></i>
    </span>
  </div>
  <br>
</div>
<div class="painel-maquinas-wrapper width-100 height-100">
  <div class="container-body">
    <!-- Loading -->
    <p class="text-cinza preloader text-center" ng-show="maquinas.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
    </p>

    <!-- List -->
    <uib-accordion close-others="false" class="resumo-users m-t panel-group">
      <div uib-accordion-group class="panel-default" ng-repeat="maquina in maquinas.maquinas | filter:maquinas.search:false:'maquina.maquina'" is-open="maquina.open">
        <uib-accordion-heading>
          <div ng-click="maquinas.expandMaquina($event, maquina)">
            {{maquina.maquina}} <i class="pull-right fa" ng-class="{'fa-minus-circle': maquina.open, 'fa-plus-circle': !maquina.open, 'text-equilibrio': maquinas.isRecent(maquina), 'text-muted': !maquinas.isRecent(maquina)}"></i>
          </div>
        </uib-accordion-heading>
        <strong class="title">Talhões visitados em {{maquina.ultimo_envio | date:'dd/MM'}}</strong>
        <ul class="list-unstyled">
          <li ng-repeat="gleba in maquina.glebas" class="pointer" uib-tooltip="{{gleba.propriedade.descricao}}"
              tooltip-placement="left" ng-click="maquinas.showTracking(maquina, gleba)" tooltip-append-to-body="true">
          <span class="pull-left">
            <i class="fa fa-spinner fa-spin" ng-show="gleba.loading"></i>
            {{gleba.gleba.descricao | characters: 25}}&nbsp;
            <i class="fa fa-eye" ng-style="{color: gleba.selected && '#' + maquina.cor}" aria-hidden="true"></i>
          </span>
            <span class="pull-right">às {{gleba.recorded_at | date:'HH:mm'}}</span>
            <div class="clearfix"></div>
          </li>
        </ul>
      </div>
    </uib-accordion>
  </div>
</div>
